import { render, staticRenderFns } from "./PlanejamentoAcaoFormUsuarioCliente.vue?vue&type=template&id=5aa8aec5"
import script from "./PlanejamentoAcaoFormUsuarioCliente.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormUsuarioCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports